import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const WelcomePopup = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('welcomeTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t('welcomeMessage')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('connect')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomePopup;
